module.exports = __webpack_public_path__ + "img/photo-team12.08e163b0.png";